import request from '@/utils/request'

export function serviceData(params) {
    return request({
      url: '/content/serviceData',
      method: 'get',
      params
    })
  }
  